import { reactive } from 'vue';

const chart = reactive({
  userList: [],
  singleUser: {},
  category: '',
});

export default chart;
